import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Stack } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { useKeyboardListControl } from '../../hooks/use-keyboard-list-control';
import { BonusCard } from '../../modules/top-navbar/components/Bonus';
import { Bonus, SearchBonus } from '../../types/bonus';
import { useSearchContext } from './context';
import { SearchResult } from './SearchResult';
import { toBonusType } from './utils';

export const BonusesPanel: FC = () => {
	const recognizeURL = useBuildRecognizeURL();
	const { bonuses, query } = useSearchContext();
	const { t } = useTranslation('navigation');
	const bonusURL = (bonus: Bonus): string => recognizeURL('bonuses', bonus.id);

	const { isSelected, register } = useKeyboardListControl<SearchBonus, HTMLAnchorElement>({
		emitClickOnSelect: true,
		focusSelected: true,
		onSelectOption: (bonus) => {
			window.location.assign(bonusURL(toBonusType(bonus)));
		},
		options: bonuses,
		selectOnTab: false,
	});

	const { track } = useAnalytics();

	return (
		<Stack as="ul" listStyleType="none">
			{bonuses?.map((bonus) => {
				const { onClick, ...props } = register(bonus);

				return (
					<SearchResult
						aria-label={t('search.result_label', {
							name: bonus.giver.display_name,
						})}
						isSelected={isSelected(bonus)}
						key={bonus.objectID}
						onClick={() => {
							track(AnalyticsEvent.TopNavbar.RecognitionClick);
							onClick();
						}}
						{...props}
					>
						<BonusCard bonus={toBonusType(bonus)} highlight={query} />
					</SearchResult>
				);
			})}
		</Stack>
	);
};
